'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewsletterModals = function NewsletterModals(el) {
  var _this = this;

  (0, _classCallCheck3.default)(this, NewsletterModals);

  this.cookieName = 'bao-newsletter-modal';
  this.newsletterModal = (0, _functional.getElement)('[data-modal="newsletter"]');
  this.newsletterDelay = this.newsletterModal.dataset.delay;
  this.newsletterSuccessModal = (0, _functional.getElement)('[data-modal="newsletter-success"]');
  this.popupNewsletterSuccessModal = (0, _functional.getElement)('[data-modal="popup-newsletter-success"]');
  this.modalHasBeenShown = false;
  this.shouldShowNewsletterModal = _jsCookie2.default.get(this.cookieName) === undefined;
  this.shouldShowNewsletterSuccessModal = window.location.href.includes('customer_posted=true');
  this.shouldShowPopupNewsletterSuccessModal = window.location.href.includes('customer_posted=true#frm-Modal_Signup');

  var showNewsletterModal = function showNewsletterModal() {
    window.setTimeout(function () {
      _this.modalHasBeenShown = true;
      _jsCookie2.default.set(_this.cookieName, 'true', {
        expires: 365
      });

      _this.newsletterModal.classList.add('mod-Modal-active');
      var close = (0, _functional.getElement)('[data-modal-close]', {
        context: _this.newsletterModal
      });
      close.addEventListener('click', function () {
        _this.newsletterModal.classList.remove('mod-Modal-active');
      }, 2000);
    }, _this.newsletterDelay);
  };

  if (this.shouldShowNewsletterModal) {
    showNewsletterModal();
  }

  if (this.shouldShowPopupNewsletterSuccessModal) {
    this.popupNewsletterSuccessModal.classList.add('mod-Modal-active');
    var close = (0, _functional.getElement)('[data-modal-close]', {
      context: this.popupNewsletterSuccessModal
    });
    close.addEventListener('click', function () {
      _this.popupNewsletterSuccessModal.classList.remove('mod-Modal-active');
    });
  } else if (this.shouldShowNewsletterSuccessModal) {
    this.newsletterSuccessModal.classList.add('mod-Modal-active');
    var _close = (0, _functional.getElement)('[data-modal-close]', {
      context: this.newsletterSuccessModal
    });
    _close.addEventListener('click', function () {
      _this.newsletterSuccessModal.classList.remove('mod-Modal-active');
    });
  }
};

exports.default = NewsletterModals;